export default __webpack_public_path__ + "static/media/bg-5.7f8f1976.png";